import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=b2e7ea78&"
import script from "./customers.vue?vue&type=script&lang=js&"
export * from "./customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e7ea78')) {
      api.createRecord('b2e7ea78', component.options)
    } else {
      api.reload('b2e7ea78', component.options)
    }
    module.hot.accept("./customers.vue?vue&type=template&id=b2e7ea78&", function () {
      api.rerender('b2e7ea78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/tabs/customers.vue"
export default component.exports